import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import Checkbox from '../../../../ui-kit/Checkbox';
import RangeSlider from '../RangeSlider';
import RwLabel from '../RwLabel';
import QuestionHint from '../../../../components/QuestionHint';
import useSoundproofing from '../../../../hooks/useSoundproofing';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import {
  SOUNDPROOFING_PRODUCT_TYPES,
  SOUNDPROOFING_RANGE_KEYS,
  SOUNDPROOFING_RANGE_LIMITS,
} from '../../../../constants/soundproofing';

const PRODUCT_TYPES_LABELS = {
  [SOUNDPROOFING_PRODUCT_TYPES.singleGlass]: DICTIONARY.soundproofingPage.singleGlass,
  [SOUNDPROOFING_PRODUCT_TYPES.laminatedGlass]: DICTIONARY.soundproofingPage.laminatedGlass,
  [SOUNDPROOFING_PRODUCT_TYPES.singleChamberUnit]: DICTIONARY.soundproofingPage.singleChamberUnit,
  [SOUNDPROOFING_PRODUCT_TYPES.doubleChamberUnit]: DICTIONARY.soundproofingPage.doubleChamberUnit,
};

// TODO: it is unknown yet how the product types and the ranges relate to the composition scheme
function CompositionParams() {
  const { t } = useTranslations();
  const {
    productTypes, toggleProductType, ranges, changeRange,
  } = useSoundproofing();

  return (
    <div className={styles.params}>
      <div className={styles.types}>
        {Object.values(SOUNDPROOFING_PRODUCT_TYPES).map((key) => (
          <div
            key={key}
            className={classNames(styles.type, 'noSelection')}
            onClick={() => toggleProductType(key)}
          >
            <Checkbox text={t(PRODUCT_TYPES_LABELS[key])} value={productTypes[key]} />
          </div>
        ))}
      </div>

      <div className={styles.ranges}>
        {Object.values(SOUNDPROOFING_RANGE_KEYS).map((key) => (
          <RangeSlider
            key={key}
            label={key === SOUNDPROOFING_RANGE_KEYS.thickness
              ? t(DICTIONARY.soundproofingPage.totalThickness)
              : <RwLabel rangeKey={key} />}
            hint={key === SOUNDPROOFING_RANGE_KEYS.thickness
              && <QuestionHint text={t(DICTIONARY.soundproofingPage.totalThicknessHint)} />}
            min={SOUNDPROOFING_RANGE_LIMITS[key].min}
            max={SOUNDPROOFING_RANGE_LIMITS[key].max}
            value={ranges[key]}
            onChange={(value) => changeRange(key, value)}
          />
        ))}
      </div>
    </div>
  );
}

export default CompositionParams;
